export default __webpack_public_path__ + "static/sign-in-2fa9b52ecc2d55439ed2d838d90720e2.jpg";